import type { AppThunk } from '@core/core/store'
import type { ProjectId } from 'common/types'

import { getAllCubesApi, getCubesByProjectIdApi } from '../../api'
import type { CubeInfo, CubeLineInfos } from '../../types'
import { addCubeToProject } from '../project'
import { cubeSlice } from './cubeSlice'

const { addCubes } = cubeSlice.actions

export const getCubes = (): AppThunk => dispatch => {
  getAllCubesApi()
    .then(cubes => dispatch(addCubes(convertToCubeLineInfos(cubes))))
    .catch(console.error)
}

export const getCubesByProjectId =
  (projectId: ProjectId): AppThunk =>
  dispatch => {
    getCubesByProjectIdApi(projectId)
      .then(cubes => {
        dispatch(addCubeToProject(cubes))
      })
      .catch(console.error)
  }

function convertToCubeLineInfos(from: CubeInfo[]): CubeLineInfos[] {
  return from.map(cube => ({ ...cube, cubeLines: [] }))
}
